import { AttachmentDetails } from 'owa-automated-message';
import { LazyImport, LazyModule } from 'owa-bundling';

const details = {
    name: 'TestFile.json',
    content: new Blob([JSON.stringify({ test: 'Test' }, null, 2)], { type: 'application/json' }),
    kind: 'File',
} as AttachmentDetails;

const testModule = { getDebugInfo: () => details };
const mockLazyModule = {
    import: () => Promise.resolve(testModule),
} as LazyModule<typeof testModule>;

export const lazyGetDebugLogAttachmentDetailsForTestArea = new LazyImport(
    mockLazyModule,
    m => m.getDebugInfo
);
